import axios from "axios";

var counter = 0;
const win: any = window;
var token = window.location.href.includes("localhost") ? "5819e16c-c5d6-4c17-b469-0146ee72e040" : win["clientToken"];
var reGenerateTokenUrl = win["regenerate_url"];
var serverURL = win["base_portal_url"];
var errorPage = win["errorPageURL"];
const CEM_KEY = window.location.href.includes("localhost") ? "liCENcCCGpHUsEPHNhySYGXCnmhwzZ" : win["CEM_KEY"];
const apiBaseURL = window.location.href.includes("localhost") ? "https://apisit.mobily.com.sa/api" : win["base_api_url"];

let config = {
  api: {
    baseURL: apiBaseURL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "",
      "x-transaction-id": "SR_12345678",
      "x-channel-id": "PORTALS",
      "cem-key": CEM_KEY,
    },
  },
};

export const api = axios.create({ ...config.api });
export const simpleApi = axios.create();

api.defaults.validateStatus = function () {
  return true;
};

api.interceptors.request.use(
  async (conf: any) => {
    console.log("token : " + token);
    conf.headers.Authorization = "Bearer " + token;
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

api.interceptors.response.use(
  async (response: any) => {
    if (
      (response.data.code && response.data.code === "APIGEE-001") ||
      (response.data.code && response.data.code === "APIGEE-002")
    ) {
      counter++;
      token = await reGenerateToken();
      const { config: oldRequest } = response;
      if (counter < 2) return api.request({ ...oldRequest });
    }

    return response;
  },
  async (error: any) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);

function reGenerateToken() {
  console.log("reGenerateToken :: Enter");
  console.log("reGenerateTokenUrl => " + serverURL + "" + reGenerateTokenUrl);

  return new Promise((resolve, reject) => {
    fetch(serverURL + "" + reGenerateTokenUrl, {
      method: "GET",
      headers: {
        "Content-type": "text/html; charset=UTF-8",
      },
    })
      .then((res) => res.text())

      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// get method

const getStoreLocator = async (data: any) => {
  if (data === 'all') {
    return api.get(
      `${apiBaseURL}/gis-google/v1/store-locator?data=${data}`
    );
  } else {
    const { lon, lat, cityName } = data;
    return api.get(
      `${apiBaseURL}/gis-google/v1/store-locator?lat=${lat}&lon=${lon}&cityName=${cityName}`
    );
  }
};

export { getStoreLocator };
